import { useState, useEffect } from "react";
import { Modal, Form, Input, Checkbox, Button, Spin, Row, Col } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import PropTypes from "prop-types";

const SuggestedModal = ({
  open,
  onCancel,
  onFinish,
  initialValues = null,
  isEditing = false,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    if (open) {
      if (isEditing && initialValues) {
        form.setFieldsValue({
          ...initialValues,
          priority:
            initialValues.priority === 1 || initialValues.priority === "1",
        });
      } else {
        form.resetFields();
        form.setFieldsValue({ priority: false });
      }
    }
  }, [open, isEditing, initialValues, form]);

  const handleOk = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      const isStringType = isEditing && typeof (initialValues?.priority) === "string";
      const transformedValues = {
        ...values,
        priority: values.priority ? (isStringType ? "1" : 1) : (isStringType ? "0" : 0),
      };
      await onFinish(transformedValues);
      form.resetFields();
    } catch (info) {
      console.log("Validate Failed:", info);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        isEditing ? (
          <FormattedMessage id="AGENTS.SUGGESTED.UPDATE_SUGGESTED" />
        ) : (
          <FormattedMessage id="AGENTS.SUGGESTED.CREATE_NEW" />
        )
      }
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel}>
          <FormattedMessage id="AGENTS.HOME.CANCEL" />
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleOk}
        >
          {isEditing ? (
            <FormattedMessage id="AGENTS.HOME.SAVE_CHANGES" />
          ) : (
            <FormattedMessage id="AGENTS.HOME.CREATE" />
          )}
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" name="suggested_form">
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="suggest"
                label={
                  <FormattedMessage id="AGENTS.HOME.TABLE_COLUMN_SUGGESTED" />
                }
                rules={[
                  {
                    required: true,
                    message: (
                      <FormattedMessage id="AGENTS.HOME.EMPTY_FIELD_WARNING" />
                    ),
                  },
                ]}
              >
                <Input.TextArea
                  rows={4}
                  placeholder={intl.formatMessage({
                    id: "AGENTS.HOME.SUGGESTED_PLACEHOLDER",
                  })}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="priority" valuePropName="checked" className="mb-0">
                <Checkbox>
                  <FormattedMessage id="AGENTS.HOME.TABLE_COLUMN_PRIORITY" />
                </Checkbox>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};

SuggestedModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  isEditing: PropTypes.bool,
};

 

export default SuggestedModal;
